module.exports = __webpack_public_path__ + "static/media/pl_PL.ef2c1261.svg";